import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { extract } from '@app/core';
import { RegisterComponent } from './register.component';
import { Shell } from '@app/shell/shell.service';

const routes: Routes = [{ path: 'register', component: RegisterComponent, data: { title: extract('Register') } }];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
  providers: []
})
export class RegisterRoutingModule {}
